import { ICategory } from 'featureSliced/shared/store/reducers/CategoriesReducer/types'
import moment from 'moment'
import { handleLocalStorage } from './handleLocalStorage'

// moment isoWeekday: 1=Mon, 2=Tue, 3=Wed, 4=Thu, 5=Fri, 6=Sat, 7=Sun
const dayKeyByIsoWeekday = {
  1: 'mon',
  2: 'tue',
  3: 'wed',
  4: 'thu',
  5: 'fri',
  6: 'sat',
  7: 'sun',
} as const

const resolveDateForCategoryAvailability = (date?: Date): Date => {
  if (date) return date

  if (process.env.REACT_APP_IS_CLIC === '1') {
    const { pickUpTime } = handleLocalStorage(['pickUpTime']) as {
      pickUpTime: string | null
    }
    if (pickUpTime) {
      const pickupMoment = moment(pickUpTime)
      if (pickupMoment.isValid()) return pickupMoment.toDate()
    }
  }

  return new Date()
}

export const isCategoryAvailableToday = (
  category: ICategory,
  date?: Date
): boolean => {
  if (!category?.products?.length) return false

  const ad = category.availableDays
  // all-false means no day restriction (empty string stored in cache) → available every day
  if (!Object.values(ad).some(Boolean)) return true

  const resolvedDate = resolveDateForCategoryAvailability(date)
  const weekday = moment(resolvedDate).isoWeekday()
  if (weekday < 1 || weekday > 7) return false

  const dayKey = dayKeyByIsoWeekday[weekday as keyof typeof dayKeyByIsoWeekday]
  return ad[dayKey] === true
}
